<div class="header">
  @if (profileLink()) {
    <a
      [href]="profileLink()"
      [target]="linkTarget()"
      rel="noopener noreferrer"
      class="profile-link"
      dataTest="post-profile-link"
    >
      <app-post-avatar [item]="item()" />
    </a>
  } @else {
    <app-post-avatar
      [item]="item()"
      [class.clickable-logo]="isClickableProfile()"
      [attr.tabindex]="isClickableProfile() ? 0 : null"
      [attr.role]="isClickableProfile() ? 'button' : null"
      (click)="onLogoClick()"
      (keydown)="onLogoKeydown($event)"
    />
  }

  @if (profileLink()) {
    <a
      [href]="profileLink()"
      [target]="linkTarget()"
      rel="noopener noreferrer"
      class="profile-link"
      dataTest="post-profile-link"
    >
      <ng-container *ngTemplateOutlet="ownerInfo" />
    </a>
  } @else {
    <ng-container *ngTemplateOutlet="ownerInfo" />
  }

  @if (userLogoUrl(); as logoUrl) {
    @if (userHomepageUrl(); as homepageUrl) {
      <a [href]="homepageUrl" target="_blank" rel="noopener noreferrer" class="user-logo-link">
        <img class="user-logo" [src]="logoUrl" alt="" />
      </a>
    } @else {
      <img class="user-logo" [src]="logoUrl" alt="" />
    }
  } @else if (shouldDisplaySocialLink()) {
    <app-post-social-link
      class="social-link"
      [item]="item()"
      [feedType]="feedType()"
      [sourceLogo]="sourceLogo()"
      [isMajiApp]="isMajiApp()"
      (socialClick)="onSocialClick($event)"
    />
  }

  @if (shouldDisplayPinned()) {
    <div class="pinned with-icon" dataTest="post-pinned">
      <outlaw-icon class="icon" size="12px" name="pinFilled" />
      Pinned
    </div>
  }
</div>

<ng-template #ownerInfo>
  <div class="owner-info">
    <div
      class="owner-title"
      [class.clickable]="isClickableProfile()"
      [attr.tabindex]="isClickableProfile() ? 0 : null"
      [attr.role]="isClickableProfile() ? 'button' : null"
      (click)="onOwnerTitleClick()"
      (keydown)="onOwnerTitleKeydown($event)"
      dataTest="post-owner"
    >
      @if (isRepost()) {
        {{ item().content.community_repost?.source?.source_user?.username | titlecase }}
      } @else {
        {{ item().user?.username | titlecase }}
      }
    </div>
    <div class="item-type with-icon" dataTest="post-type">
      @if (postTypeIcon(); as icon) {
        <outlaw-icon class="icon" [name]="icon" size="12px" dataTest="post-type-icon" />
      }
      <div class="type-name" dataTest="post-type-name">
        {{ postTypeText() }}
      </div>
    </div>

    @if (showDateInHeader()) {
      <div class="date" dataTest="post-posted_date">
        {{ item().posted_at | unixDateFormatter }}
      </div>
    }
  </div>
</ng-template>
